import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from './guards/auth.guard';
import { NoAuthGuard } from './guards/no-auth.guard';
import { AppMainComponent } from './main/app.main.component';
import { LoginComponent } from './login/login.component';
import { AppErrorComponent } from 'src/assets/pages/error/app.error.component';
import { AppAccessdeniedComponent } from 'src/assets/pages/acceso-denegado/app.accessdenied.component';
import { AppNotfoundComponent } from 'src/assets/pages/not-found/app.notfound.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { PoliticaPrivacidadComponent } from './login/politica-privacidad/politica-privacidad.component';

const appRoutes: Routes = [
    {
        path: '', component: AppMainComponent, canActivate: [AuthGuard], children: [

            {
                path: 'conductores/listado-servicios', loadChildren: () => import('../shared/components/listado-servicios/listado-servicios.module').then(m => m.ListadoServiciosModule)
            },
            {
                path: 'conductores/anomalias', loadChildren: () => import('../shared/components/anomalias/anomalias.module').then(m => m.AnomaliasModule)
            },
            {
                path: 'conductores/mensajeria', loadChildren: () => import('../shared/components/mensajeria/mensajeria.module').then(m => m.MensajeriaModule)
            },
            {
                path: 'taxis', canActivate: [AuthGuard], loadChildren: () => import('../shared/components/taxis/taxis.module').then(m => m.TaxisModule)
            },
            {
                path: 'test', canActivate: [AuthGuard], loadChildren: () => import('../shared/components/test/test.module').then(m => m.TestModule)
            },
            {
                path: 'service', canActivate: [AuthGuard], loadChildren: () => import('../shared/components/abrir-servicio/abrir-servicio.module').then(m => m.AbrirServicioModule)
            },
            { path: 'notificaciones', component: NotificationsComponent },
            {
                path: '', redirectTo: 'listado-servicios', pathMatch: 'full'
            }
        ]
    },
    {
        path: 'politica-privacidad', component: PoliticaPrivacidadComponent
    },
    { path: 'error', component: AppErrorComponent },
    { path: 'access', component: AppAccessdeniedComponent },
    { path: 'notfound', component: AppNotfoundComponent },
    { path: 'login', component: LoginComponent, canActivate: [NoAuthGuard] },
    { path: '**', redirectTo: '/notfound' },
]
@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes)
    ]
})
export class AppRoutingModule {
}